import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_simulator.gif';
import { ItemSimulator } from '../../lib/ItemUtil';
import ListBase, { ListBaseProps } from '../lib/ListBase';

class SimulatorList extends ListBase {

    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Simulator';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemSimulator;
        const authors = item.developer.map((author, i) => {
            return <Fragment key={i}>{i > 0 && ', '}{Functions.mlang(author, lang)}</Fragment>
        });
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link><br />
                {authors}
            </>
        );
    }
}

export default SimulatorList;